/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ordered_By_Time_ToastInputs */



/**
* | output |
* | --- |
* | "Events ordered by time successfully" |
*
* @param {Shortcut_Keys_Ordered_By_Time_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ordered_by_time_toast = /** @type {((inputs?: Shortcut_Keys_Ordered_By_Time_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ordered_By_Time_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenements tries par temps avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse erfolgreich nach Zeit sortiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi ordinati correttamente in base al tempo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События, упорядоченные по времени, успешно завершены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos ordenados por tiempo con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按时间排序的事件成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントは時間順に並べられました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय के अनुसार क्रमबद्ध की गई घटनाएँ सफलतापूर्वक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos ordenados por tempo com sucesso")
	return /** @type {LocalizedString} */ ("Events ordered by time successfully")
});